import type { ReactNode } from "react";

import FooterLesson from "./FooterLesson";
import HeaderLesson from "./HeaderLesson";

interface ContentMessageProps {
    message: string;
    header?: ReactNode; // Overrides the default header
    footer?: ReactNode; // Overrides the default footer
}

// Full-page layout that shows a single centered message (loading, error, empty, unsupported...)
const ContentMessage = ({
                            message,
                            header = <HeaderLesson />,
                            footer = <FooterLesson />
                        }: ContentMessageProps) => (
    <div className="min-h-screen flex flex-col">
        {header}

        <main className="flex-1 flex items-center justify-center">
            <p>{message}</p>
        </main>

        {footer}
    </div>
);

export default ContentMessage;